import { fetchGetService, fetchPostService } from '@modules/api'
import axios from 'axios'

const state = {
  // autoLoginStatus: false,
  // loginStatus: false,
  isLoggedIn: false,
  token: '',
  errorMessage: '',
  forgetPassword: false,
  originalRoute: '/'
}

const getters = {
  getToken: state => state.token,
  getErrorMessage: state => state.errorMessage,
  getForgetPassword: state => state.forgetPassword,
  getOriginalRoute: state => state.originalRoute,
  getIsLoggedIn: state => state.isLoggedIn
  // getAutoLoginStatus: state => state.autoLoginStatus,
  // getLoginStatus: state => state.loginStatus,
}

const mutations = {
  // UPDATE_AUTO_LOGIN_STATUS: (state, boolean) => {
  //   state.autoLoginStatus = boolean
  // },
  // UPDATE_LOGIN_STATUS: (state, boolean) => {
  //   state.loginStatus = boolean
  // },
  UPDATE_IS_LOGGED_IN: (state, boolean) => {
    state.isLoggedIn = boolean
  },
  UPDATE_TOKEN: (state, string) => {
    state.token = string
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.defaults.headers.common['X-CSRF-TOKEN'] = string
  },
  UDPATE_ERROR_MESSAGE: (state, string) => {
    state.errorMessage = string
  },
  UDPATE_FORGET_PASSWORD: (state, boolean) => {
    state.forgetPassword = boolean
  },
  UPDATE_ORIGINAL_ROUTE: (state, string) => {
    state.originalRoute = string
  }
}

const actions = {
  updateErrorMessage: ({ commit }, message) => {
    commit('UDPATE_ERROR_MESSAGE', message)
  },
  updateForgetPassword: ({ commit }, forgetPassword) => {
    commit('UDPATE_FORGET_PASSWORD', forgetPassword)
  },
  updateOriginalRoute: ({ commit }, routePath) => {
    commit('UPDATE_ORIGINAL_ROUTE', routePath)
  },
  requestAutoLogin ({ commit }) {
    return new Promise((resolve) => {
      fetchGetService('check-user')
        .then(({ data }) => {
          commit('UPDATE_TOKEN', data.token)
          commit('UPDATE_IS_LOGGED_IN', data.success)
          resolve()
        })
    })
  },
  requestLogin ({ dispatch, commit }, { email, password, remember }) {
    return new Promise((resolve) => {
      fetchPostService('login', { email, password, remember })
        .then(({ data }) => {
          commit('UPDATE_TOKEN', data.token)
          if (data.error && !data.success) {
            dispatch('updateErrorMessage', data.error)
          }
          commit('UPDATE_IS_LOGGED_IN', data.success)
          resolve()
        })
    })
  },
  requestLostPassword ({ commit, dispatch }, { email }) {
    dispatch('updateErrorMessage', '')
    return new Promise((resolve, reject) => {
      // POST
      fetchPostService('lost-password', { email })
        .then(({ data }) => {
          commit('UPDATE_TOKEN', data.token)
          dispatch('updateForgetPassword', false)
          if (data.error && !data.success) {
            dispatch('updateErrorMessage', data.error)
          }
          resolve(data)
        })
    })
  },
  requestNewPassword ({ commit, dispatch }, { email, token, password, passwordConfirmation }) {
    return new Promise((resolve, reject) => {
      fetchPostService('new-password', { email, token, password, password_confirmation: passwordConfirmation })
        .then(({ data }) => {
          commit('UPDATE_TOKEN', data.token)

          if (data.error && !data.success) {
            dispatch('updateErrorMessage', data.error)
          }
          resolve()
          document.location.href = '/'
        })
    })
  },

  async requestLogout ({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      fetchPostService('logout')
        .then(() => {
          window.location.reload()
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
